<template>
	<div>
		<v-row class="mt-sm-3 body-transaction-product body-transaction-product-sm">
			<v-col cols="12" class="pt-0">
				<template>
					<div class="px-3 d-none d-sm-flex flex-wrap">
						<v-col sm="2" md="1" class="py-0"></v-col>
						<v-col sm="3" md="7" class="pl-md-5 py-0">
							<div class="font-size-11 font-weight-bold">Item</div>
						</v-col>
						<v-col sm="2" md="1" class="py-0 text-sm-center">
							<div class="font-size-11 font-weight-bold">Qty</div>
						</v-col>
						<v-col sm="2" md="1" class="py-0 text-sm-center">
							<div class="font-size-11 font-weight-bold">Berat</div>
						</v-col>
						<v-col sm="3" md="2" class="py-0 text-sm-right">
							<div class="font-size-11 font-weight-bold">Total</div>
						</v-col>
					</div>
					<v-card class="mt-3 pa-3 elevation-0 rounded-xl hover-shadow" v-for="product in firstData" :key="product.product_id">
						<div class="d-flex flex-wrap">
							<v-col cols="3" sm="2" md="1" class="py-0 px-0">
								<v-img contain width="80px" height="80px" class="rounded-xl" :src="product.product_image ? product.product_image : 'assets/image/user-pict.jpg'"></v-img>
							</v-col>
							<v-col cols="9" sm="3" md="7" class="pl-sm-0 pl-md-5 py-0 my-auto">
								<div class="cl-dark-green font-size-xs-10 font-size-11">{{ product.product_name }}</div>
								<div class="cl-primary font-size-xs-10 font-size-11">
									{{ product.product_price | toRupiah }}
								</div>
								<div class="cl-grey font-size-10">{{ product.product_weight | toKg }}</div>
							</v-col>
							<v-col cols="3" sm="2" md="1" class="pb-0 py-sm-0 my-auto text-sm-center">
								<div class="cl-dark-green font-size-xs-10 font-size-11 font-weight-bold">
									<span class="font-weight-bold d-sm-none">x</span>
									{{ parseInt(product.quantity) }}
								</div>
							</v-col>
							<v-col cols="3" sm="2" md="1" class="pb-0 py-sm-0 my-auto text-sm-center">
								<div class="cl-dark-green font-size-xs-10 font-size-11 font-weight-bold">{{ (product.product_weight * product.quantity) | toKg }}</div>
							</v-col>
							<v-col cols="6" sm="3" md="2" class="pb-0 py-sm-0 my-auto text-right">
								<div class="cl-dark-green font-size-xs-10 font-size-11 font-weight-bold">{{ product.total | toRupiah }}</div>
							</v-col>
						</div>
					</v-card>
				</template>
				<template>
					<div class="mt-3 d-flex flex-wrap justify-end">
						<v-col md="6" class="pa-0">
							<v-card class="pa-3 elevation-0 rounded-xl hover-shadow">
								<div class="pa-3">
									<div class="d-flex flex-wrap justify-space-between">
										<div class="cl-dark-green font-size-xs-10 font-size-11">Total Berat</div>
										<div class="cl-dark-green font-size-xs-10 font-size-11 font-weight-bold">{{ sumWeight | toKg }}</div>
									</div>
									<div class="pt-2 d-flex flex-wrap justify-space-between">
										<div class="cl-dark-green font-size-xs-10 font-size-11">Total Harga</div>
										<div class="cl-dark-green font-size-xs-10 font-size-11 font-weight-bold">{{ sumTotal | toRupiah }}</div>
									</div>
								</div>
							</v-card>
						</v-col>
					</div>
				</template>
				<template>
					<v-card class="mt-3 pa-3 elevation-0 rounded-xl hover-shadow">
						<div class="d-flex flex-wrap justify-space-between">
							<v-col cols="12" sm="6" class="py-0 my-auto">
								<div class="cl-dark-green font-size-xs-11 font-size-12 font-weight-bold">Pilih metode pengiriman</div>
							</v-col>
							<v-col cols="12" sm="4" md="4" lg="3" class="mt-n2 pt-3 pt-sm-0 text-right">
								<v-autocomplete hide-details="auto" placeholder="Pilih Metode" color="primary" no-data-text="Belum ada data yang dapat ditampilkan" :items="shipping_method" item-text="text" item-value="value" v-model="shipping_method_value" @change="changeShippingMethod"></v-autocomplete>
							</v-col>
						</div>
					</v-card>
				</template>
				<template v-if="shipping_method_value == 'logistic'">
					<v-card class="mt-3 pa-3 elevation-0 rounded-xl hover-shadow">
						<div class="px-3 d-flex">
							<v-icon class="cl-primary">mdi-map-marker-outline</v-icon>
							<div class="pl-1 cl-primary font-size-xs-10 font-size-11 font-weight-bold">Alamat Pengiriman</div>
						</div>
						<div class="pt-4 d-flex flex-wrap" v-if="Object.keys(address_data).length > 0">
							<v-col cols="12" sm="3" md="3" class="py-0">
								<div>
									<div class="cl-light-grey font-size-xs-9 font-size-10">Nama Penerima</div>
									<div class="pt-1 cl-dark-green font-size-xs-10 font-size-11 font-weight-bold">{{ address_data.receiver_name }}</div>
								</div>
								<div class="pt-3">
									<div class="cl-light-grey font-size-xs-9 font-size-10">Nomor Handphone</div>
									<div class="pt-1 cl-dark-green font-size-xs-10 font-size-11 font-weight-bold">{{ address_data.receiver_phone }}</div>
								</div>
							</v-col>
							<v-col cols="12" sm="7" md="7" class="py-sm-0">
								<div>
									<div class="cl-light-grey font-size-xs-9 font-size-10">Alamat</div>
									<div class="pt-1 cl-dark-green font-size-xs-10 font-size-11 font-weight-bold">
										<div>{{ address_data.receiver_address }}</div>
										<div>{{ joinAddress }}</div>
									</div>
								</div>
							</v-col>
							<v-col cols="12" sm="2" md="2" class="pt-2 pb-0 py-sm-0 my-auto text-right">
								<v-btn width="100" depressed color="orange lighten-4" class="rounded-pill" @click="showModalAlamat">
									<span class="pr-2 text-capitalize font-size-xs-10 font-size-11 font-weight-bold">Ubah</span>
								</v-btn>
							</v-col>
							<v-col cols="12" class="pb-0">
								<!-- <template v-if="myProfile.member_province_id > 0 && myProfile.member_city_id > 0 && myProfile.member_subdistrict_id > 0 && myProfile.member_address">
									<div class="cl-primary font-size-xs-10 font-size-11 font-weight-bold cursor-pointer text-underline d-inline-block" @click="useMainAddress">Gunakan Alamat Utama</div>
								</template> -->
							</v-col>
						</div>
						<div class="pt-4 d-flex flex-wrap" v-else>
							<v-col cols="3" sm="2" md="1" class="py-0 pr-0">
								<v-img contain width="80px" height="80px" src="assets/ilustration/ilustrasi-alamat-kosong.svg"></v-img>
							</v-col>
							<v-col cols="9" sm="8" md="9" class="pl-md-5 py-0 my-auto">
								<div class="cl-dark-green font-size-xs-10 font-size-11">Silakan pilih alamat pengiriman terlebih dahulu</div>
								<!-- <template v-if="myProfile.member_province_id > 0 && myProfile.member_city_id > 0 && myProfile.member_subdistrict_id > 0 && myProfile.member_address">
									<div class="pt-1 cl-primary font-size-xs-10 font-size-11 font-weight-bold cursor-pointer text-underline d-inline-block" @click="useMainAddress">Gunakan Alamat Utama</div>
								</template> -->
							</v-col>
							<v-col cols="12" sm="2" md="2" class="pb-0 py-sm-0 my-auto text-right">
								<v-btn width="100" depressed color="teal lighten-5" class="rounded-pill" @click="showModalAlamat">
									<span class="pr-2 text-capitalize font-size-xs-10 font-size-11 font-weight-bold">Pilih</span>
								</v-btn>
							</v-col>
						</div>
					</v-card>
				</template>
				<template v-if="shipping_method_value == 'logistic' && Object.keys(address_data).length > 0">
					<v-card class="mt-3 pa-3 elevation-0 rounded-xl hover-shadow">
						<div class="d-flex flex-wrap" v-if="Object.keys(courier_data).length > 0">
							<v-col cols="12" sm="3" md="3" class="py-0 my-auto">
								<div class="cl-dark-green font-size-xs-10 font-size-11 font-weight-bold">Jasa Pengiriman</div>
							</v-col>
							<v-col cols="12" sm="4" md="5" class="pb-0 py-sm-0 my-auto">
								<div class="cl-dark-green font-size-xs-10 font-size-11 font-weight-bold">{{ courier_data.expedition_name }}</div>
								<div class="cl-dark-green font-size-xs-10 font-size-11">{{ courier_data.expedition_service }}</div>
								<div class="cl-light-grey font-size-10" v-if="courier_data.etd">Estimasi sampai {{ courier_data.etd }} hari</div>
							</v-col>
							<v-col cols="12" sm="3" md="2" class="pt-0 py-sm-0 my-auto text-right">
								<div class="cl-dark-green font-size-xs-10 font-size-11 font-weight-bold">{{ courier_data.expedition_price | toRupiah }}</div>
							</v-col>
							<v-col cols="12" sm="2" md="2" class="py-0 my-auto text-right">
								<v-btn width="100" depressed color="orange lighten-4" class="rounded-pill" @click="showModalKurir">
									<span class="pr-2 text-capitalize font-size-xs-10 font-size-11 font-weight-bold">Ubah</span>
								</v-btn>
							</v-col>
						</div>
						<div class="d-flex flex-wrap" v-else>
							<v-col cols="3" sm="2" md="1" class="py-0 pr-0">
								<v-img contain width="80px" height="80px" src="assets/ilustration/ilustrasi-shipping-kosong.svg"></v-img>
							</v-col>
							<v-col cols="9" sm="8" md="9" class="pl-md-5 py-0 my-auto">
								<div class="cl-dark-green font-size-xs-10 font-size-11">Silakan pilih jasa pengiriman terlebih dahulu</div>
							</v-col>
							<v-col cols="12" sm="2" md="2" class="py-0 my-auto text-right">
								<v-btn width="100" depressed color="teal lighten-5" class="rounded-pill" @click="showModalKurir">
									<span class="pr-2 text-capitalize font-size-xs-10 font-size-11 font-weight-bold">Pilih</span>
								</v-btn>
							</v-col>
						</div>
					</v-card>
				</template>
				<template v-if="shipping_method_value == 'pick-up'">
					<v-card color="teal lighten-4" class="mt-3 pa-3 elevation-0 rounded-xl">
						<div class="d-flex flex-wrap">
							<v-col cols="12" class="py-0 d-flex">
								<v-icon>mdi-alert-circle</v-icon>
								<div class="pl-2 cl-dark-green font-size-11 my-auto">Untuk metode 'Pick Up' member bersedia mengambil pesanan ke Gudang Pusat</div>
							</v-col>
						</div>
					</v-card>
					<v-card class="mt-3 pa-3 elevation-0 rounded-xl">
						<div class="d-flex flex-wrap">
							<v-col cols="12" sm="6" class="py-0">
								<div class="cl-dark-green font-size-xs-11 font-size-12 font-weight-bold">Total Pembayaran</div>
							</v-col>
							<v-col cols="12" sm="6" class="pt-3 pt-sm-0 pb-0 text-right">
								<div class="cl-dark-green font-size-xs-11 font-size-12 font-weight-bold">{{ parseInt(sumTotal) | toRupiah }}</div>
							</v-col>
						</div>
					</v-card>
				</template>
				<template v-if="shipping_method_value == 'logistic'">
					<template v-if="Object.keys(courier_data).length > 0">
						<v-card class="mt-3 pa-3 elevation-0 rounded-xl">
							<div class="d-flex flex-wrap">
								<v-col cols="12" sm="6" class="py-0">
									<div class="cl-dark-green font-size-xs-11 font-size-12 font-weight-bold">Total Pembayaran</div>
								</v-col>
								<v-col cols="12" sm="6" class="pt-3 pt-sm-0 pb-0 text-right">
									<div class="cl-dark-green font-size-xs-11 font-size-12 font-weight-bold">{{ parseInt(sumTotal) + parseInt(this.courier_data.expedition_price) | toRupiah }}</div>
								</v-col>
							</div>
						</v-card>
					</template>
				</template>
			</v-col>
		</v-row>
		<div class="footer-transaction-product rounded-xl">
			<div class="d-flex flex-wrap">
				<v-col cols="12" class="pb-0 px-0 pa-sm-0 text-right my-auto">
					<v-btn large width="130" depressed color="grey lighten-3" class="rounded-pill" @click="showModalBack">
						<v-icon>mdi-arrow-left</v-icon>
						<span class="pl-2 text-capitalize font-size-xs-10 font-size-11 font-weight-bold">Kembali</span>
					</v-btn>
					<v-btn large width="120" depressed color="primary" class="ml-2 rounded-pill" :disabled="btn_disabled" @click="showModalKonfirmasi">
						<span class="pr-2 text-capitalize font-size-xs-10 font-size-11 font-weight-bold">Proses</span>
						<v-icon>mdi-check-all</v-icon>
					</v-btn>
				</v-col>
			</div>
		</div>
		<ModalAlamat ref="modalAlamat" @action="getAdress"></ModalAlamat>
		<ModalKurir ref="modalKurir" @action="getCourier"></ModalKurir>
		<ModalBack ref="modalBack" :msg="msgBack" @action="processBack"></ModalBack>
		<ModalKonfirmasi ref="modalKonfirmasi" :msg="msgConfirm" @action="processTransaction"></ModalKonfirmasi>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalAlamat from './components/ModalAlamat';
import ModalKurir from './components/ModalKurir';
import ModalBack from '@/components/modals/vo-general/ModalKonfirmasi';
import ModalKonfirmasi from '@/components/modals/vo-general/ModalKonfirmasi';

export default {
	components: {
		ModalAlamat, ModalKurir, ModalBack, ModalKonfirmasi
	},
	data() {
		return {
			btn_disabled: true,
			address_data: {},
			courier_data: {},
			second_data: {
				transaction_received_name: '',
				transaction_received_address: '',
				transaction_received_mobilephone: '',
				transaction_received_province_id: '',
				transaction_received_province_name: '',
				transaction_received_city_id: '',
				transaction_received_city_name: '',
				transaction_received_subdistrict_id: '',
				transaction_received_subdistrict_name: '',
				transaction_expedition_name: '',
				transaction_expedition_service: '',
				transaction_expedition_price: '',
				transaction_detail: [],
			},
			shipping_method: [
			// { text: 'Pick Up', value: 'pick-up' },
			{ text: 'Jasa Logistik', value: 'logistic' },
			],
			shipping_method_value: '',
			msgConfirm: 'Apakah Anda yakin untuk memproses transaksi?',
			msgBack: 'Jika kembali Anda harus memilih ulang produk. Yakin ingin kembali?',
		}
	},
	props: {
		firstData: Array,
		stockist_data: Object,
	},
	computed: {
		...mapState('profile', ['myProfile']),

		sumWeight() {
			let weight = 0
			this.firstData.forEach((el) => {
				weight += parseInt(el.product_weight) * el.quantity
			})
			return weight
		},
		sumTotal() {
			let total = 0
			this.firstData.forEach((el) => {
				total += parseInt(el.total)
			})
			return total
		},
		joinAddress() {
			if (this.address_data.receiver_city.city_type) {
				let address = this.address_data.receiver_subdistrict.subdistrict_name + ', ' + this.address_data.receiver_city.city_type + ' ' + this.address_data.receiver_city.city_name + ', ' + this.address_data.receiver_province.province_name
				return address
			} else {
				let address = this.address_data.receiver_subdistrict.subdistrict_name + ', ' + this.address_data.receiver_city.city_name + ', ' + this.address_data.receiver_province.province_name
				return address
			}
		}
	},
	methods: {
		...mapActions('profile', ['getProfileMitra']),
		...mapActions('transaksiProduk', ['addTransaction']),

		changeShippingMethod() {
			if (this.shipping_method_value == 'logistic') {
				this.btn_disabled = true
			} else {
				this.btn_disabled = false
			}
		},
		showModalAlamat() {
			this.$refs.modalAlamat.modalShow()
		},
		showModalKurir() {
			let total_weight = this.sumWeight
			let courier_origin_type = 'city'
			let courier_origin_id = this.stockist_data.stockist_city_id
			let courier_destination_type = 'city'
			let courier_destination_id = this.address_data.receiver_city.city_id

			this.$refs.modalKurir.modalShow({total_weight, courier_origin_type, courier_origin_id, courier_destination_type, courier_destination_id})
		},
		getAdress(data) {
			let clone_address = { ...data }
			this.address_data = Object.assign(clone_address)

			this.courier_data = {}
			this.btn_disabled = true
			if (this.address_data.length > 0) {
				this.$refs.modalKurir.reset()
			}
		},
		getCourier(data) {
			let clone_courier = { ...data }
			this.courier_data = Object.assign(clone_courier)
			this.btn_disabled = false
		},
		useMainAddress() {
			let data = {}
			data.receiver_province = {}
			data.receiver_city = {}
			data.receiver_subdistrict = {}
			data.receiver_name = this.myProfile.member_name
			data.receiver_phone = this.myProfile.member_mobilephone
			data.receiver_province.province_id = this.myProfile.member_province_id
			data.receiver_province.province_name = this.myProfile.member_province_name
			data.receiver_city.city_id = this.myProfile.member_city_id
			data.receiver_city.city_name = this.myProfile.member_city_name
			data.receiver_subdistrict.subdistrict_id = this.myProfile.member_subdistrict_id
			data.receiver_subdistrict.subdistrict_name = this.myProfile.member_subdistrict_name
			data.receiver_address = this.myProfile.member_address

			this.address_data = Object.assign(data)
		},
		resetData() {
			this.second_data.transaction_received_name = ''
			this.second_data.transaction_received_address = ''
			this.second_data.transaction_received_mobilephone = ''
			this.second_data.transaction_received_province_id = ''
			this.second_data.transaction_received_province_name = ''
			this.second_data.transaction_received_city_id = ''
			this.second_data.transaction_received_city_name = ''
			this.second_data.transaction_received_subdistrict_id = ''
			this.second_data.transaction_received_subdistrict_name = ''
			this.second_data.transaction_expedition_name = ''
			this.second_data.transaction_expedition_service = ''
			this.second_data.transaction_expedition_price = ''
			this.second_data.transaction_detail = []
		},
		nextStep(step, shipping) {
			if (step == 'back') {
				this.$emit('action', step)
				this.courier_data = {}
				this.btn_disabled = true
				if (this.address_data.length > 0) {
					this.$refs.modalKurir.reset()
				}
			} else if (step == 'next') {
				this.$emit('action', step, shipping)
			}
		},
		showModalBack() {
			this.$refs.modalBack.modalShow()
		},
		showModalKonfirmasi() {
			this.$refs.modalKonfirmasi.modalShow()
		},
		processBack() {
			this.$refs.modalBack.modalHide()
			this.nextStep('back')
		},
		processTransaction() {
			this.$refs.modalKonfirmasi.loadingButton()

			/* fill second_data */
			// this.firstData.forEach((el) => {
			// 	this.second_data.transaction_product.push(el.product_code)
			// 	this.second_data.transaction_product_qty.push(el.quantity)
			// })

			this.firstData.forEach((el) => {
				this.second_data.transaction_detail.push({
					product_code: el.product_code,
					product_qty: el.quantity,
				})
			})

			this.second_data.transaction_stockist_code = this.stockist_data.stockist_code
			this.second_data.transaction_received_name = this.address_data.receiver_name
			this.second_data.transaction_received_address = this.address_data.receiver_address
			this.second_data.transaction_received_mobilephone = this.address_data.receiver_phone
			this.second_data.transaction_received_province_id = this.address_data.receiver_province.province_id
			this.second_data.transaction_received_province_name = this.address_data.receiver_province.province_name
			this.second_data.transaction_received_city_id = this.address_data.receiver_city.city_id
			this.second_data.transaction_received_city_name = this.address_data.receiver_city.city_name
			this.second_data.transaction_received_subdistrict_id = this.address_data.receiver_subdistrict.subdistrict_id
			this.second_data.transaction_received_subdistrict_name = this.address_data.receiver_subdistrict.subdistrict_name
			this.second_data.transaction_expedition_name = this.courier_data.expedition_name
			this.second_data.transaction_expedition_service = this.courier_data.expedition_service
			this.second_data.transaction_expedition_price = this.courier_data.expedition_price

			this.addTransaction(this.second_data).then(()=> {
				this.$refs.modalKonfirmasi.modalHide()
				this.$refs.modalKonfirmasi.normalButton()
				this.nextStep('next', this.shipping_method_value)
			}).catch(()=> {
				this.$refs.modalKonfirmasi.normalButton()
			})
		},
	},
	created() {
		// this.getProfileMitra()
	},
};
</script>